import React, { useEffect, useRef, useState } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { Interview, InterviewQuestion } from 'builder/modules/interview/types'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { Question } from '../Question/Question'
import LockIcon from '../../assets/LockIcon'
import {
  PanelContainer,
  PanelContentWrapper,
  PanelHeader,
  PanelItem,
  QuestionContainer,
  SectionContainer,
  ToggleSectionIcon,
} from './styles'
import PanelContent from './PanelContent'

interface PanelProps {
  questions: InterviewQuestion[]
  interview: Interview
  interviewId?: number
  isUserPremium: boolean
}
export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2`
const Panel: React.FC<PanelProps> = ({ questions, interview, interviewId, isUserPremium }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0)
  const panelContentWrapperRef = useRef(questions.map(() => React.createRef<HTMLDivElement>()))
  const readyRef = useRef(false)

  const togglePanel = (index: number) => {
    if (!isUserPremium && index > 0) {
      goToBillingPlanPage({
        forceReferrerPage: 'interviewPrep',
        onSuccessRedirect: window.location.pathname,
      })
      trackInternalEvent('click_upgrade_paywall', {
        label: 'interview_prep',
        parameter: 'feedback',
      })
    } else {
      setOpenIndex(openIndex === index ? null : index)
    }
  }

  useEffect(() => {
    if (typeof openIndex === 'number' && readyRef.current) {
      panelContentWrapperRef.current[openIndex].current?.scrollIntoView({
        block: 'start',
      })
    }
    readyRef.current = true
  }, [openIndex])

  return (
    <PanelContainer>
      {questions.map((question, index) => (
        <PanelItem
          data-question-id={question.id}
          key={index}
          ref={panelContentWrapperRef.current[index]}
        >
          <PanelHeader onClick={() => togglePanel(index)}>
            <SectionContainer>
              <QuestionContainer>
                <Question question={question?.content} questionNumber={index + 1} />
              </QuestionContainer>

              {!isUserPremium && index > 0 ? (
                <LockIcon />
              ) : (
                <ToggleSectionIcon $isOpen={openIndex === index} />
              )}
            </SectionContainer>
          </PanelHeader>
          {(isUserPremium || index === 0) && (
            <PanelContentWrapper isOpen={openIndex === index}>
              <PanelContent
                interview={interview}
                interviewId={interviewId}
                questionId={question.id}
                index={index}
                isUserPremium={isUserPremium}
              />
            </PanelContentWrapper>
          )}
        </PanelItem>
      ))}
    </PanelContainer>
  )
}

export default Panel
